export enum SeverityLevel {
  Verbose = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4,
}

export function parseSeverityLevel(value: unknown): SeverityLevel {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return clampSeverity(value);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();

    // Numeric strings like "1"
    const asNumber = Number(trimmed);
    if (!Number.isNaN(asNumber) && Number.isFinite(asNumber)) {
      return clampSeverity(asNumber);
    }

    // Named values (defensive)
    switch (trimmed.toLowerCase()) {
      case 'verbose':
      case 'trace':
      case '0':
        return SeverityLevel.Verbose;
      case 'information':
      case 'info':
      case '1':
        return SeverityLevel.Information;
      case 'warning':
      case 'warn':
      case '2':
        return SeverityLevel.Warning;
      case 'error':
      case 'err':
      case '3':
        return SeverityLevel.Error;
      case 'critical':
      case 'fatal':
      case '4':
        return SeverityLevel.Critical;
    }
  }

  return SeverityLevel.Information;
}

function clampSeverity(value: number): SeverityLevel {
  if (value <= 0) return SeverityLevel.Verbose;
  if (value === 1) return SeverityLevel.Information;
  if (value === 2) return SeverityLevel.Warning;
  if (value === 3) return SeverityLevel.Error;
  return SeverityLevel.Critical;
}
